document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".wtb-results")) {
        import(/* webpackChunkName: "where-to-buy-results" */ "/Features/WhereToBuy/js/where-to-buy-results.js").then((module) => {
            const whereToBuyResults = new module.default();
            window.whereToBuyResults = whereToBuyResults;
            whereToBuyResults.init();
        });
    }
});
